var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhitepaper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 19 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.062 6.984V.875H1.077C.448.875 0 1.369 0 1.953v20.844c0 .629.45 1.078 1.078 1.078h15.094c.584 0 1.078-.45 1.078-1.078V8.062h-6.11c-.628 0-1.077-.449-1.077-1.078Zm2.875 10.602c0 .314-.27.539-.54.539H4.852a.519.519 0 0 1-.54-.54v-.358c0-.27.225-.54.54-.54h7.547c.27 0 .539.27.539.54v.359Zm0-2.875c0 .314-.27.539-.54.539H4.852a.519.519 0 0 1-.54-.54v-.358c0-.27.225-.54.54-.54h7.547c.27 0 .539.27.539.54v.359Zm0-3.234v.359c0 .314-.27.539-.54.539H4.852a.519.519 0 0 1-.54-.54v-.358c0-.27.225-.54.54-.54h7.547c.27 0 .539.27.539.54Zm4.312-5.122c0-.27-.135-.539-.314-.763l-4.403-4.403c-.224-.18-.494-.314-.763-.314h-.27v5.75h5.75v-.27Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitepaper);
export default __webpack_public_path__ + "static/media/whitepaper.abd1569dd20e6b372b1f3ada4b565b9e.svg";
export { ForwardRef as ReactComponent };